import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const TopLine = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 10px;
  min-height: 10px;
  background: ${({ isChristmas }: { isChristmas: boolean }) =>
    isChristmas
      ? 'linear-gradient(90deg, #B30303 0%, #6D57E0 100%)'
      : 'linear-gradient(90deg, #273a4b 0%, #6c56e0 100%)'};
`;

export const Content = styled.div`
  position: relative;
  padding-top: 70px;
  padding-left: 90px;
  display: flex;
  flex-direction: column;
  height: 100%;

  @media (max-width: 768px) {
    padding-left: 80px;
  }
`;

export const Section = styled.section`
  padding: 0 40px;
  display: flex;
  height: 100%;

  @media (max-width: 1025px) {
    padding-right: 20px;
  }

  @media (max-width: 768px) {
    padding: 0;
    padding-right: 10px;
  }
`;
